export default {
    DE_0_A_16_ANOS: 1,
    DE_17_A_30_ANOS: 2,
    DE_31_A_40_ANOS: 3,
    DE_41_A_50_ANOS: 4,
    DE_51_A_59_ANOS: 5,
    DE_60_OU_MAIS: 6,
}